<template>
	<div>
		<CModal title="Ajouter un règlement" size="lg" :show.sync="showModal">
			<form ref="mainForm" action="/api/pos_invoice_payments" method="post" axiosMethod="post">
				<input type="hidden" name="invoice" :value="posInvoice['@id']" />

				<CRow>
					<CCol sm="6">
						<CSelect label="Methode de paiement" :options="paymentOptions" name="method" />
					</CCol>

					<CCol sm="6">
						<CInput name="amount" label="Montant (€)" />
					</CCol>

					<CCol col="12">
						<div role="group" class="form-group">
							<vc-date-picker
								:value="$moment().format('YYYY-MM-DD HH:mm')"
								:model-config="modelConfig"
								:masks="masks"
								mode="dateTime"
								is24hr>
								<template v-slot="{ inputValue, inputEvents }">
									<div role="group" class="form-group">
										<label for="payment-date">Date du règlement</label>
										<div class="input-group">
											<input
												id="payment-date"
												type="text"
												class="form-control"
												:value="$moment(inputValue).format('DD/MM/YYYY HH:mm')"
												v-on="inputEvents" />
											<input type="hidden" name="paymentDate" :value="inputValue" />
											<div class="input-group-append">
												<span class="input-group-text">
													<CIcon name="cil-calendar" />
												</span>
											</div>
											<small class="form-text text-muted w-100"
												>Exemple: 06/12/2021 09:57</small
											>
										</div>
									</div>
								</template>
							</vc-date-picker>
						</div>
					</CCol>

					<CCol col="12">
						<CTextarea
							name="additionalInfo"
							row="40"
							col="6"
							label="Informations complémentaires sur le paiement"
							placeholder="numéro de chèque, référence du virement, raison, note..." />
					</CCol>
				</CRow>
			</form>

			<template #footer>
				<CButton color="secondary" v-on:click="showModal = false">Fermer</CButton>
				<CButton color="success" v-on:click="onSubmit($refs.mainForm)">Sauvegarder</CButton>
			</template>
		</CModal>
	</div>
</template>

<script>
	export default {
		name: 'payment-add-modal',
		data() {
			return {
				masks: {
					L: 'YYYY-MM-DD',
				},
				modelConfig: {
					type: 'string',
				},
				showModal: false,
				posInvoice: {},
				paymentOptions: [
					{
						label: 'Espèces',
						value: 'pos_invoice_payment.cash',
					},
					{
						label: 'Chèque',
						value: 'pos_invoice_payment.check',
					},
					{
						label: 'Virement bancaire',
						value: 'pos_invoice_payment.bank_transfer',
					},
					{
						label: 'Prélèvement bancaire',
						value: 'pos_invoice_payment.direct_debit',
					},
				],
			};
		},

		methods: {
			onSubmit: function (form) {
				this.$formDataToApi.sendForm(form).then(res => {
					if (res.status === 200 || res.status === 201) {
						this.showModal = false;
						this.$emit('refresh');
					}
				});
			},
		},
	};
</script>
